const villa_sec1_part3Object = (payload) => {
  return {
    type: "villasec1part3",
    payload,
  };
};

export default villa_sec1_part3Object;
